@if (view$ | async; as view) {
    <div class="card mb-3">
        <div class="card-body key-value-list">
            <div class="card-title">
                <h5>{{ 'utilities_meter_information' | translate }}</h5>
            </div>

            <ul class="list-group list-group-flush description-list">
                <li class="list-group-item">
                    <span>{{ 'titles_system' | translate: 'online' : 'common' }}</span>
                    <span>{{ view.buildingNo }} {{ meterData.systemName }}</span>
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_proBraLoc' | translate: 'online' : 'systems' }}</span>
                    <span
                        >{{ meterData.propertyNo }}-{{ meterData.branchNo }}-{{
                            meterData.locationNo
                        }}</span
                    >
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_address' | translate: 'online' : 'systems' }}</span>
                    <span>{{ meterData.address }}</span>
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_meterNo' | translate: 'online' : 'systems' }}</span>
                    <span>{{ meterData.meterNo }}</span>
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_meterModel' | translate: 'online' : 'systems' }}</span>
                    <span>{{ meterData.model }}</span>
                </li>

                @if (deviceDetailsEnabled()) {
                    <li class="list-group-item" data-testid="radio-technology">
                        <span>{{ 'utilities_radio_technology' | translate }}</span>
                        <span>
                            @if (meterData.radioTechnology != null) {
                                {{ 'radiotechnology_' + meterData.radioTechnology | translate }}
                            }
                        </span>
                    </li>
                }

                <li class="list-group-item">
                    <span>{{ 'properties_usage' | translate: 'online' : 'systems' }}</span>
                    <span>{{
                        'mappers_allocationUnitMap.' + meterData.allocationUnit
                            | translate: 'online' : 'common'
                    }}</span>
                </li>

                <li class="list-group-item">
                    <span>{{ 'properties_mountingDate' | translate: 'online' : 'common' }}</span>
                    <span>{{ meterData.mountingDate | appdate }}</span>
                </li>

                @if (meterData.dismountedDate) {
                    <li class="list-group-item" data-testid="dismounted-date">
                        <span>{{ 'utilities_dismount-date' | translate }}</span>
                        <span>{{ meterData.dismountedDate | appdate }}</span>
                    </li>
                }
            </ul>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body key-value-list">
            <div class="card-title">
                <h5>{{ 'utilities_Installation_information' | translate }}</h5>
            </div>
            @if (meterData.meterType) {
                <ul class="list-group list-group-flush description-list">
                    @if (meterData.meterType === 1) {
                        <li class="list-group-item">
                            <span>{{ 'properties_scale' | translate: 'online' : 'systems' }}</span>
                            <span>{{ meterData.scale | appnumber }}</span>
                        </li>

                        <li class="list-group-item">
                            <span>{{ 'utilities_technical_factor' | translate }}</span>
                            <span>{{ meterData.unitFactor | appnumber }}</span>
                        </li>
                    }
                    @if ([2, 6].includes(meterData.meterType)) {
                        <li class="list-group-item">
                            <span>{{ 'utilities_meter_connection' | translate }}</span>
                            <span>{{ meterData.meterConnectionType }}</span>
                        </li>

                        <li class="list-group-item">
                            <span>{{ 'utilities_shutoff_valve' | translate }}</span>
                            <span>{{ meterData.shutoffValve | shutoffvalve }}</span>
                        </li>

                        <li class="list-group-item">
                            <span>{{ 'utilities_size_flow' | translate }}</span>
                            <span>{{ meterData.meterSize }}</span>
                        </li>
                    }
                    @if ([2, 5, 6].includes(meterData.meterType)) {
                        <li class="list-group-item">
                            <span>{{ 'utilities_meter_build_length' | translate }}</span>
                            <span>{{ meterData.meterBuildLength | appnumber }}</span>
                        </li>
                    }
                    @if (meterData.meterType === 5) {
                        <li class="list-group-item">
                            <span>{{ 'utilities_mounted_din' | translate }}</span>
                            <span>
                                <app-true-false
                                    [value]="meterData.dinRail ?? false"></app-true-false>
                            </span>
                        </li>

                        <li class="list-group-item">
                            <span>{{ 'utilities_max_current' | translate }}</span>
                            <span>{{ meterData.maxCurrent | appnumber }}</span>
                        </li>
                    }
                    @if (meterData.meterType === 6) {
                        <li class="list-group-item">
                            <span>{{ 'utilities_sensor_pocket' | translate }}</span>
                            <span>
                                <app-true-false
                                    [value]="meterData.sensorPocket ?? false"></app-true-false>
                            </span>
                        </li>

                        <li class="list-group-item">
                            <span>{{ 'utilities_flow' | translate }}</span>
                            <span>{{ meterData.supplyOrReturnFlow }}</span>
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
}
